var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"previous-step__container"},[(_vm.deepLinkData && _vm.deepLinkData.page === 'dealerSelect')?_c('button',{staticClass:"previous-step__link",on:{"click":_vm.backToTestDrive}},[_vm._v("Back a step")]):_c('button',{staticClass:"previous-step__link",on:{"click":_vm.back}},[_vm._v("Back a step")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a5c84c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/cms-content-slices/components/electric-test-drive/PreviousStep.vue
// module id = lyPv
// module chunks = 21